import React, { createContext, useState, useEffect, ReactNode } from 'react';

interface ContextStoreProviderProps {
    children: ReactNode;
}

type ToastType = {
    message: string;
    id:number;
    color:string
}


export const AuthContext = createContext<any | null>(null);;

const ContextStoreProvider: React.FC<ContextStoreProviderProps> = ({ children }) => {
    const [user, setUser] = useState({});
    const [isAuthenticated, setIsAuthenticated] = useState(false);   
    const [toasts, setToasts] = useState<ToastType[]>([])
    const [selectedSport, setSelectedSport] = useState<string>('')
    const [team, setTeam] = useState({});
    const [isModalClosed, setIsModalClosed] = useState(true);
    // to display toast notifocations incase of network issues
    useEffect(() => {
        const handleOnline = () => openToast('Internet reconnected!', "green");
        const handleOffline = () => openToast('You are offline!', "red");

        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    },);


    function openToast(message: string, color:string) {
        const newToast = {
            id: Date.now(),
            message: message,
            color:color
        };

        setToasts((previousToasts) => [...previousToasts, newToast])
        // Automatically close the toast after 2 seconds
        setTimeout(() => {
            closeToast(newToast.id);
        }, 2000);
    }

    function closeToast(id:number){
        setToasts((previousToasts)=> previousToasts.filter(toast => toast.id !== id))
    }

    return (
        <AuthContext.Provider value={{user, setUser, isAuthenticated, setIsAuthenticated, toasts, openToast, closeToast, selectedSport, setSelectedSport, team, setTeam, isModalClosed, setIsModalClosed }}>           
            { children}
        </AuthContext.Provider>
    )
};

export default ContextStoreProvider
